// extracted by mini-css-extract-plugin
export default {"buttonContainer":"InternalQuotaButton_buttonContainer__6IdOU","buttonContent":"InternalQuotaButton_buttonContent__EPREm"};